(function () {
  'use strict';

  var root = document.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js');

  function applyLanguage(language) {
    var isEnglish = language === 'en';
    root.classList.toggle('is-freya-en', isEnglish);
    root.lang = isEnglish ? 'en' : 'zh-Hant';

    document.querySelectorAll('[data-freya-lang-toggle]').forEach(function (button) {
      button.textContent = isEnglish ? '中文' : 'EN';
      button.setAttribute('aria-label', isEnglish ? '切換至中文' : 'Switch to English');
      button.setAttribute('aria-pressed', String(isEnglish));
    });

    document.querySelectorAll('.freya-lang-zh').forEach(function (element) {
      element.setAttribute('aria-hidden', String(isEnglish));
    });
    document.querySelectorAll('.freya-lang-en').forEach(function (element) {
      element.setAttribute('aria-hidden', String(!isEnglish));
    });

    if (document.body && document.body.dataset.homepage === 'true') {
      document.title = isEnglish ? document.body.dataset.titleEn : document.body.dataset.titleZh;
    }
  }

  function bindLanguageButtons() {
    document.querySelectorAll('[data-freya-lang-toggle]').forEach(function (button) {
      if (button.dataset.freyaBound === 'true') return;
      button.dataset.freyaBound = 'true';
      button.addEventListener('click', function () {
        applyLanguage(root.classList.contains('is-freya-en') ? 'zh' : 'en');
      });
    });
  }

  bindLanguageButtons();
  applyLanguage('zh');

  document.addEventListener('shopify:section:load', function () {
    bindLanguageButtons();
    applyLanguage(root.classList.contains('is-freya-en') ? 'en' : 'zh');
  });
})();
